const BASE_PROPS = {
  format: new Set(['png', 'pdf']),
  access_type: new Set(['free', 'one_time', 'pro']),
  watermarked: new Set(['true', 'false']),
};

export const POST_EXPORT_SURVEY_SHOWN_PROPS = BASE_PROPS;
export const POST_EXPORT_SURVEY_SUBMITTED_PROPS = {
  ...BASE_PROPS,
  use_case: new Set(['client_report', 'presentation_print', 'website', 'school_personal', 'other']),
  frequency: new Set(['once', 'monthly', 'weekly', 'unsure']),
};
export const POST_EXPORT_SURVEY_DISMISSED_PROPS = {
  ...BASE_PROPS,
  dismiss_reason: new Set(['close_button', 'keep_editing', 'timeout']),
};
